import React from "react";
import { useNavigate } from "react-router-dom";
import Header, { MenuOptions } from "../../Global/Header/Header";
import Footer from "../../Global/Footer/Footer";
import classes from "./InfluencerClub.module.css";

const InfluencerClub = () => {
  const width = window.innerWidth;

  const navigate = useNavigate();

  const hostHandler = () => {
    navigate("/influencer-registration");
  };

  const featureTrip = [
    {
      item1: "Earn",
      item2: "Enhanced earnings",
      item3:
        "Amplify your income by sharing your unique adventures with a passionate community",
      img: "https://static.wixstatic.com/media/da937f_3b7e435177fc4d94a10459e0c41009e1~mv2.png/v1/fill/w_348,h_232,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/WEBSITE%20CONTENT%20(4).png",
    },
    {
      item1: "Build",
      item2: "Verified Profiles",
      item3:
        "Connect with a trusted community of verified, adventure-loving enthusiasts",
      img: "https://static.wixstatic.com/media/da937f_428a78dd91de4a05bfb382f8e5deb386~mv2.png/v1/fill/w_348,h_232,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/WEBSITE%20CONTENT%20(5).png",
    },
    {
      item1: "Bonus",
      item2: "Royality Rewards",
      item3:
        "Earn ongoing royalties for each itinerary, creating a long-lasting revenue stream",
      img: "https://static.wixstatic.com/media/da937f_36ec67b2a1c548b0ae725225747fe047~mv2.png/v1/fill/w_348,h_232,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/WEBSITE%20CONTENT%20(3).png",
    },
  ];

  const influencerReview = [
    {
      locationName: "Udaipur",
      month: "(August 2023)",
      rev: "Influencer Escapades",
      review:
        "Exploro has truly revolutionized the travel industry! As a pilot and fashion influencer, I curated a remarkable trip to Udaipur, and thanks to Exploro, I could share my passion for travel and fashion with my followers. Exploro provided a platform for travel influencers like me to earn while creating unforgettable experiences for people who dreamt of traveling with their favorite influencers. It's an incredible opportunity for both influencers and travel enthusiasts alike",
      name: "Praggya Sethi",
      curatorImg:
        "https://static.wixstatic.com/media/da937f_8d7eafcece0d46059c0bbe9a506f5f06~mv2.webp",
      bgImg:
        "https://static.wixstatic.com/media/da937f_ab50e2b9977448d7b55e51c5fca333a6~mv2.png/v1/fill/w_337,h_350,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/2.png",
    },
    {
      locationName: "Munsiyari",
      month: "(September 2023)",
      rev: "Influencer Escapades",
      // eslint-disable-next-line
      review:
        "I couldnt put it any better than this, “Exploro has made my bucket list destinations come to life”. Had Spiti Valley, Munsiyari, and Kashmir as my dream destinations for quite a while. All three came to life when I joined hands with Exploro club.The backend operations, accommodations, within journey halts all were perfectly taken care of by the team with rarely any hassle that I had to go through in order to set things straight.",
      name: "Rishab Nag",
      curatorImg:
        "https://static.wixstatic.com/media/da937f_e6cd0d12adc4473eb248c0f90d4382ec~mv2.png/v1/fill/w_366,h_473,al_c,lg_1,q_85,enc_auto/IMG_0126-removebg-preview_edited.png",
      bgImg:
        "https://static.wixstatic.com/media/da937f_0faba1a7c4184d67a5c41a0f8bde0f5e~mv2.png/v1/fill/w_337,h_350,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/6.png",
    },
    {
      locationName: "Varkala",
      month: "(September 2023)",
      rev: "Best Experience",
      review: `So I went with Exploro to Tirthan Jibhi Valley as a curator and my time working with the team has been incredibly positive and rewarding. As a curator, I appreciated the creative freedom I was given to design unique and memorable itinerary. Exploro’s support and openness to new ideas allowed me to craft personalized journeys for travelers, ensuring they had authentic and immersive experiences in every destination. Moreover, I was impressed by the efficiency with which the agency handled logistics and organization. From accommodations and transportation to activities and dining recommendations, every aspect of the itinerary was meticulously planned and flawlessly executed. It made my role as a curator much easier, knowing that I could rely on your agency’s expertise and attention to detail.`,
      name: "Swarnali",
      curatorImg:
        "https://static.wixstatic.com/media/da937f_f309e99d6d924dc59dee011629dd90b6~mv2.webp",
      bgImg:
        "https://static.wixstatic.com/media/da937f_e19ecb2c6d784af189ef3743ea411fb4~mv2.png/v1/fill/w_337,h_350,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/5.png",
    },
  ];

  return (
    <>
      <div className="block">
        <img
          className="hidden sm:block w-full h-112 lg:h-full object-cover"
          src="https://static.wixstatic.com/media/174eab_c3e7bd395f8c42daafd0c4e9a2336fbe~mv2.png/v1/crop/x_0,y_27,w_1440,h_846/fill/w_1351,h_793,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/For%20Influencers%201.png"
          alt=""
        />
        <div className="absolute top-0 left-0 right-0 bg-[#f6dcdc] sm:bg-transparent">
          <Header activeTab={MenuOptions.INFLUENCER_CLUB} />
        </div>
        <div className="sm:ms-6 lg:ms-20 lg:w-2/3 sm:absolute top-0 mt-28 lg:mt-36 lg:text-left left-0 right-0 flex flex-col items-center sm:block bg-[#f6dcdc] sm:bg-transparent">
          <p
            className={
              "font-Aeonik text-4xl sm:text-3xl lg:text-6xl text-start text-black"
            }
          >
            Welcome to
          </p>
          <div className="flex flex-row">
            <p
              className={
                "font-Aeonik text-4xl sm:text-3xl lg:text-6xl text-orange-600"
              }
            >
              Influencers
            </p>
            <p
              className={
                "font-Aeonik text-4xl sm:text-3xl lg:text-6xl lg:ms-5 ms-2 text-black"
              }
            >
              Club
            </p>
          </div>
          <p
            className={
              "lg:text-xl text-2xl mt-2 mx-[4vw] sm:mx-0 text-center sm:text-left lg:mt-3"
            }
          >
            Discover adventure, share experiences
          </p>
          <button
            onClick={hostHandler}
            className={
              "bg-orange-600 rounded-md sm:rounded-full border border-solid border-white border-opacity-10 px-6 py-2 mt-2 lg:mt-8 text-white font-Aeonik text-sm lg:text-xl"
            }
          >
            Host your trip
          </button>
          <img
            className="block sm:hidden"
            src="https://static.wixstatic.com/media/174eab_c3e7bd395f8c42daafd0c4e9a2336fbe~mv2.png/v1/crop/x_0,y_27,w_1440,h_846/fill/w_1351,h_793,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/For%20Influencers%201.png"
            alt=""
          />
        </div>
      </div>
      <div className="mt-8">
        <p className={classes["feature-trip-heading"]}>
          Why host and itinerary with exploro?
        </p>
        <p className={classes["underline"]}>__________</p>

        <div className={classes["feature-trip"]}>
          {featureTrip.map((ft, index) => {
            return (
              <div className={classes["feature-1"]}>
                {index === 1 && width > 1000 ? (
                  <>
                    <div
                      style={{ marginRight: "11vw" }}
                      className={classes["feature-1-text"]}
                    >
                      <p className={classes["feature-1-item-1"]}>{ft.item1}</p>
                      <p className={classes["feature-1-item-2"]}>{ft.item2}</p>
                      <p className={classes["feature-1-item-3"]}>{ft.item3}</p>
                      <button
                        onClick={hostHandler}
                        className={classes["feature-button-host-trip"]}
                      >
                        Host your trip
                      </button>
                    </div>
                    <img
                      style={{ marginRight: "0" }}
                      className={classes["feature-1-img"]}
                      src={ft.img}
                      alt=""
                    />
                  </>
                ) : (
                  <>
                    <img
                      className={classes["feature-1-img"]}
                      src={ft.img}
                      alt=""
                    />

                    <div className={classes["feature-1-text"]}>
                      <p className={classes["feature-1-item-1"]}>{ft.item1}</p>
                      <p className={classes["feature-1-item-2"]}>{ft.item2}</p>
                      <p className={classes["feature-1-item-3"]}>{ft.item3}</p>
                      <button
                        onClick={hostHandler}
                        className={classes["feature-button-host-trip"]}
                      >
                        Host your trip
                      </button>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>

        <p className={classes["influencer-review-heading"]}>
          What top influencers says about us
        </p>
        <p className={classes["underline"]}>__________</p>
        <div className={classes["new-inf-card-container"]}>
          {influencerReview.map((inf) => {
            return (
              <div className={classes["new-inf-card"]}>
                <img
                  className={classes["new-inf-img"]}
                  src={inf.curatorImg}
                  style={{ backgroundImage: `url(${inf.bgImg})` }}
                  alt=""
                />
                <p
                  className={`${classes["hide-scroll"]} ${classes["new-inf-review"]}`}
                >
                  {inf.review}
                </p>
              </div>
            );
          })}
        </div>
        {/* <div className={classes['influencer-review-container']} >
                {
                    influencerReview.map(inf=>{
                        return (          
                            <div className={classes['inf-rev-card']}>
                                <img className={classes['inf-rev-bgImg']} src={inf.bgImg} alt="" />
                                <img className={classes['semicolon-img']} src="https://static.wixstatic.com/media/da937f_4465ba2382404b23852f8a39ac8c79ea~mv2.png/v1/crop/x_241,y_242,w_111,h_97/fill/w_42,h_36,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(12).png" alt="" />

                                <p className={classes['inf-dest-name']}>{inf.locationName}</p>
                                <p className={classes['inf-month']}>{inf.month}</p>
                                <p className={classes['inf-rev']}>{inf.rev}</p>
                                <p className={classes['influencer-rev']}>{inf.review}</p>
                                <p className={classes['inf-name']}>{inf.name}</p>
                                <img className={classes['inf-rev-img']} src={inf.curatorImg} alt="" />
                            </div>
                        )
                    })
                }
                
            </div> */}

        <Footer />
      </div>
    </>
  );
};

export default InfluencerClub;
